<!-- <div class="modal fade" id="modaluploadnewversion" tabindex="-1"
	role="dialog"> -->
<div class="modal-dialog">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				[attr.data-dismiss]="'modal'" type="button"
				(click)="createForm(documento);">Chiudi</button>
		</p>

		<div doc_update_metadati_form [documento]="documento" [separatorePathLogico]="separatorePathLogico"
			#docUpdateMetadatiForm (onReturnModal)="manageModal($event)"></div>
	</div>
</div>
<!-- </div> -->
